module.exports = __webpack_public_path__ + "static/media/3.9cef69d0.jpg";